// extracted by mini-css-extract-plugin
export default {"secondary":"AutocompleteOptionLabel_secondary__aY9I3"};